import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "propertyManagement",
    defaultRoutePath: "/propertymanagement/property",
    menuItemScope: "operations",
    menuItemName: "property",

    routes: [
        {
            path: "/propertymanagement/property",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "createFromScraping",
            Component: Wizards.CreateFromScraping,
        },
        {
            path: "generateClip",
            Component: Wizards.GenerateClip,
        },
    ],
};

export default Module;
